import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/global.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Mobile viewport fix for Instagram and other in-app browsers
const setViewportHeight = () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
};

// Set viewport height on load and resize
window.addEventListener('load', setViewportHeight);
window.addEventListener('resize', setViewportHeight);
window.addEventListener('orientationchange', setViewportHeight);

// Instagram in-app browser detection and fixes
const isInstagramInApp = () => {
  return /Instagram/.test(navigator.userAgent);
};

// Apply Instagram-specific fixes
if (isInstagramInApp()) {
  // Force viewport height update for Instagram
  setInterval(setViewportHeight, 100);
  
  // Remove any fixed positioning issues
  document.body.style.position = 'relative';
  document.body.style.height = 'auto';
  document.body.style.overflow = 'auto';
}

// Scroll restoration for mobile
const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
};

// Listen for route changes and scroll to top
window.addEventListener('popstate', scrollToTop);

// Add this to prevent scroll jumping on mobile
document.addEventListener('DOMContentLoaded', () => {
  // Prevent scroll restoration on mobile
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
  }
  
  // Additional Instagram fixes
  if (isInstagramInApp()) {
    // Ensure body is scrollable
    document.body.style.overflow = 'auto';
    document.body.style.position = 'relative';
    
    // Fix for Instagram's viewport issues
    const meta = document.querySelector('meta[name="viewport"]');
    if (meta) {
      meta.setAttribute('content', 'width=device-width, initial-scale=1.0, viewport-fit=cover');
    }
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
